import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { toast } from 'react-toastify';

const useStyles = makeStyles((theme) => ({

    container: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        //  height: "880px",
    },
    wrapper: {
        width: "680px",
        margin: "30px",
        "@media (max-width: 770px)": {
            width: "95%",
            margin: "0px",
        }
    },
    textbox: {
        overflowX: "hidden",
        overflowY: "auto",
        height: "153px",
        padding: "20px 35px",
        color: "#666",
        fontSize: "15px",
        fontWeight: "400",
        lineHeight: "23px",
        backgroundColor: "#fff"
    },
    button: {

        backgroundColor: theme.palette.primary.main,
        display: "block",
        border: "0px",
        color: "#fff",
        textAlign: "center",
        height: "80px",
        fontSize: "30px",
        width: "400px",
        borderRadius: "34px",
        margin: "40px",
        "&:hover": {
            cursor: "pointer"
        },
        "@media (max-width: 770px)": {
            width: "80%",
        }

    }
}))

const Agreement = ({ history }) => {

    const [check, setCheck] = useState({ check1: false, check2: false });

    const { check1, check2 } = check;

    const style = useStyles();

    const onClick = () => {

        if (check1 === false || check2 === false) {
            toast.error("약관에 모두 동의해주시기 바랍니다.");
        } else {
            history.push("/signup");
        }

    }

    const onChange = (e) => {

        const { checked, name } = e.target;

        setCheck({
            ...check,
            [name]: checked
        });
    };

    return (
        <div className={style.container}>
            <div className={style.wrapper}>
                <h1>SurBay 회원가입</h1>
                <h2>약관동의</h2>
                <FormControlLabel control={<Checkbox color="primary" checked={check1} name="check1" onChange={onChange} />} label="개인정보 수집·이용에 동의합니다.(필수)" />

                <div className={style.textbox}>제1장 총직<br /><br />
                    제 1조(목적)<br />
                    SurBay 서비스 이용약관은 회사가 서비스를 제공함에 있어, 회사와 이용자간의 권리, 의무 및 책임 사항 등을 규정함을 목적으로 합니다.<br /><br />
                    제1장 총직<br /><br />
                    제 1조(목적)<br />
                    SurBay 서비스 이용약관은 회사가 서비스를 제공함에 있어, 회사와 이용자간의 권리, 의무 및 책임 사항 등을 규정함을 목적으로 합니다.
                </div>
                <br />
                <br />

                <FormControlLabel control={<Checkbox color="primary" checked={check2} name="check2" onChange={onChange} />} label="서베이 운영정책의 동의합니다.(필수)" />

                <div className={style.textbox}>제1장 총직<br /><br />
                    제 1조(목적)<br />
                    SurBay 서비스 이용약관은 회사가 서비스를 제공함에 있어, 회사와 이용자간의 권리, 의무 및 책임 사항 등을 규정함을 목적으로 합니다.<br /><br />
                    제1장 총직<br /><br />
                    제 1조(목적)<br />
                    SurBay 서비스 이용약관은 회사가 서비스를 제공함에 있어, 회사와 이용자간의 권리, 의무 및 책임 사항 등을 규정함을 목적으로 합니다.
                </div>

            </div>
            <button className={style.button} onClick={onClick}>다음</button>
        </div>

    );
};

export default Agreement;